import { MetricQuery, operationLabels } from "../metrics.types";

export function describeWindowOperation(metricQuery: MetricQuery): string {
    if (!metricQuery.window) {
        return "";
    }

    const { size, applyLast, operation } = metricQuery.window;
    const operationLabel = operationLabels[operation].toLowerCase();
    const timing = applyLast ? "last" : "first";

    const periodLabel =
        metricQuery.periodResolution === "m"
            ? "month"
            : metricQuery.periodResolution === "q"
              ? "quarter"
              : "year";

    return `${size}-${periodLabel} rolling ${operationLabel}, applied ${timing}`;
}
